import { render } from "./SearchSummary.vue?vue&type=template&id=eab53ca2"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"
script.render = render

export default script